import { createSelector } from 'reselect'

const getFeaturesSelected = (state, layerName) => {
  return state.object.featuresSelected
}

const getLayerName = (state, layerName) => {
  return layerName
}

export const makeGetFeaturesSelected = () => {
  return createSelector(
    [getFeaturesSelected, getLayerName],
    (featuresSelected, layerName) => {
      if (featuresSelected && layerName) {
        return featuresSelected.filter(
          feature => feature.layer.id === layerName
        )
      } else {
        return []
      }
    }
  )
}



// WEBPACK FOOTER //
// ./src/selectors/featureSelector.js